import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

  /* Example of a CSS reset */
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Global styles */
  body {
    background-color: var(--mainlight);
    color: var(--darktext);
    margin: 0;
    font-family: "futura-pt", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-variant-ligatures: none;
  }

  .futura-light {
  font-family: "futura-pt", sans-serif;
  font-weight: 300; /* Light */
  font-stretch: normal;
}

.futura-regular {
  font-family: "futura-pt", sans-serif;
  font-weight: 400; /* Regular */
  font-stretch: normal;
}

.futura-medium {
  font-family: "futura-pt", sans-serif;
  font-weight: 500; /* Medium */
  font-stretch: normal;
}

.futura-semibold {
  font-family: "futura-pt", sans-serif;
  font-weight: 600; /* Semi-bold */
  font-stretch: normal;
}

.futura-bold {
  font-family: "futura-pt", sans-serif;
  font-weight: 700; /* Bold */
  font-stretch: normal;
}


  html {
    scroll-behavior: smooth;
  }

  :root {
    --bg-pink: #FFA0FF;
    --accent-pink: #E036E0;
    --accent-turkoise: #40BFCC;
    --mainlight: #FFFEF7;
    --cardgrey: #f8f8f8;
    --contrastlight: #FFF9DE;
    --maindark: #252525;

   
    // old colors
    --text: #FFF9DE;
    --darktext: #330a1f;
    --fade-green: #cdeae0;
    --bg-green: #CAE7DD;
  }

  p {
    margin: 0;
  }

  img, picture, video, canvas, svg {
    display: block;
  }

  input, button, textarea, select {
    font: inherit;
  }

  #root, #__next {
    isolation: isolate;
    height: 100%;
  }

  /* Utility classes */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  /* Global for modal */
  .lock-scroll {
    overflow: hidden;
  }
`;
